module.exports = __webpack_public_path__ + "static/img/surpris_shadow.c65ea13.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions/surpris_shadow.png
// module id = 398B
// module chunks = 0